import axiosInstance from '../utils/axiosInstance';
import { BASE_URL } from '../constants'
import {createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import { refreshAccessToken } from '../utils/refreshAccessToken';


const userDetails = JSON.parse(localStorage.getItem('userDetails'));


const getApi = (endPoint) => ({
    get: async () => {
        //getting  parsed token from  local storage userDetails

        const token = userDetails?.token;

        let headers = {
            Authorization: `Bearer ${token}`,
            "Content-Type": "application/json"
        }

        let options = {
            url: `${BASE_URL}${endPoint}`,
            method: 'get',
            headers: headers,
            withCredentials: true,
            responseType: "json",  // Handle as blob for file download
        }

        try {
            return await axiosInstance(options);
        } catch (error) {
            if (error.response?.status === 401) {
                const newToken = await refreshAccessToken(); // Get new token
                options.headers.Authorization = `Bearer ${newToken}`; // Update header with new token
                return await axiosInstance(options); // Retry the original request
            }
            throw error;
        }
    },
    post: async data => {
        const token = userDetails?.token;

        let headers = {

        }
        if (token) {
            headers = {
                Authorization: `Bearer ${token}`,
                "Content-Type": "application/json"
            }
        }

        const options = {
            url: `${BASE_URL}${endPoint}`,
            method: 'post',
            data,
            headers: headers,
            withCredentials: true
        }

        // console.log("Iam options :",options);    
        try {
            return await axiosInstance(options);
        } catch (error) {
            if (error.response?.status === 401) {
                const newToken = await refreshAccessToken(); // Get new token
                options.headers.Authorization = `Bearer ${newToken}`; // Update header with new token
                return await axiosInstance(options); // Retry the original request
            }
            throw error;
        }

    },
    patch: async data => {
        const token = userDetails?.token;
        const options = {
            url: `${BASE_URL}${endPoint}`,
            method: 'patch',
            data,
            headers: {
                Authorization: `Bearer ${token}`
            },
            withCredentials: true,
        }
        try {
            return await axiosInstance(options);
        } catch (error) {
            if (error.response?.status === 401) {
                const newToken = await refreshAccessToken(); // Get new token
                options.headers.Authorization = `Bearer ${newToken}`; // Update header with new token
                return await axiosInstance(options); // Retry the original request
            }
            throw error;
        }
    },
    put: async data => {
        const token = userDetails?.token;
        const options = {
            url: `${BASE_URL}${endPoint}`,
            method: 'put',
            data,
            headers: {
                Authorization: `Token ${token}`
            },
            withCredentials: true
        }
        try {
            return await axiosInstance(options);
        } catch (error) {
            if (error.response?.status === 401) {
                const newToken = await refreshAccessToken(); // Get new token
                options.headers.Authorization = `Bearer ${newToken}`; // Update header with new token
                return await axiosInstance(options); // Retry the original request
            }
            throw error;
        }
    },
    delete: async data => {
        const token = userDetails?.token;
        const options = {
            url: `${BASE_URL}${endPoint}`,
            method: 'delete',
            data,
            headers: {
                Authorization: `Token ${token}`
            },
            withCredentials: true

        }
        try {
            return await axiosInstance(options);
        } catch (error) {
            if (error.response?.status === 401) {
                const newToken = await refreshAccessToken(); // Get new token
                options.headers.Authorization = `Bearer ${newToken}`; // Update header with new token
                return await axiosInstance(options); // Retry the original request
            }
            throw error;
        }
    },
})

export default function sliceCreator(sliceName, endPoint, method) {

    const action = createAsyncThunk(
        (`${sliceName}/${method}`).toUpperCase(),
        async (data, { rejectWithValue }) => {
            try {
                const response = await getApi(data?.endPoint || endPoint)[method](data);
                // console.log(response, "response")
                return response.data
            } catch (err) {
                 const payload = err?.response?.data ?? {
                    success: false,
                    statusCode: err?.response?.status ?? null,
                    message: err?.message || 'Request failed',
                    error: err?.name || 'AxiosError',
                    details: null,
                };
                return rejectWithValue(payload);
            }
        }
    )

    const clearData = `${(method).toUpperCase()}/clear`;

    const slice = createSlice({
        name: (sliceName).toUpperCase(),
        initialState: {
            loading: false,
            successData: null,
            error: false,
            errorInfo: null
        },
        reducers: {
            [clearData]: () => { return {} }
        },
        extraReducers: builder => {
            builder
                .addCase(action.pending, (state, action) => {
                    state.loading = true;
                    state.successData = null;
                    state.error = false;
                    state.errorInfo = null;
                })
                .addCase(action.rejected, (state, action) => {
                    state.loading = false;
                    state.successData = null;
                    state.error = true;
                    state.errorInfo = action.payload?.message || action.payload?.non_field_errors;
                })
                .addCase(action.fulfilled, (state, action) => {
                    state.loading = false;
                    state.successData = action.payload === "" ? {success: true} : action.payload;
                    state.error = false;
                    state.errorInfo = null;
                });
        }

    })

    return {
        reducer: slice.reducer,
        asyncAction: action,
        clearData: slice.actions[clearData]
    };
}